import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import mixins from './mixins'

const GlobalMixins = new mixins()

Vue.config.productionTip = false

export const StemWijzerHTTP = axios.create({
	baseURL: GlobalMixins.config.settings.analytics ? GlobalMixins.config.settings.analytics.baseUrl : ''
})

Vue.use(VueClipboard)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
